import { StubPage } from '../components/StubPage';

export function QuantumCompaniesPage() {
  return (
    <StubPage
      title="Quantum Companies"
      description="CRUD des sociétés quantiques tracées (financeforquantum.com/companies/<slug>). Enrichissement éditorial : tech approach, milestone, sources."
      icp="Gaetan en mode admin, pour maintenir la base des sociétés quantum servie sur le site, en complément des investors."
      status="PR 1 stub"
      tableTarget="QuantumCompanies (existante dans Founder Directory)"
      reads={['Name', 'Slug', 'HQ', 'Stage', 'Tech approach', 'TRL', 'Last round amount / date', 'Status', 'Data quality']}
      edits={['Status, Data quality inline', 'Technology brief, Latest milestone, Differentiation, Sources en side-panel']}
      relations={['Lead investor', 'Non-dilutive programs', 'Linked funds (InvestorProfiles enhanced)']}
    />
  );
}
